<template>
  <div>
    <section v-if="campsite.timezone" class="location-subsection">
      <translate tag="h3"> Timezone </translate>
      <p>{{ campsite.timezone }}</p>
    </section>

    <section v-if="latLng.lat && latLng.lng" class="location-subsection">
      <translate tag="h3"> GPS </translate>
      <p>
        <template v-if="latLng.lat >= 0">
          <translate :tt="{ lat: Math.abs(latLng.lat) }">
            {lat, puNumber, maximumFractionDigits:5}°N
          </translate>
        </template>
        <template v-else>
          <translate :tt="{ lat: Math.abs(latLng.lat) }">
            {lat, puNumber, maximumFractionDigits:5}°S
          </translate>
        </template>
        <br />
        <template v-if="latLng.lng >= 0">
          <translate :tt="{ lng: Math.abs(latLng.lng) }">
            {lng, puNumber, maximumFractionDigits:5}°E
          </translate>
        </template>
        <template v-else>
          <translate :tt="{ lng: Math.abs(latLng.lng) }">
            {lng, puNumber, maximumFractionDigits:5}°W
          </translate>
        </template>
      </p>
    </section>

    <section v-if="campsite.location.directions" class="location-subsection">
      <translate tag="h3"> Route directions </translate>
      <div
        v-thtml="campsite.location.directions"
        class="prerendered preserve-linebreaks"
      />
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { CampsiteDetails } from '~/apps/campsite-details/types'
import { getPointFromStringOrDefault } from '~/utility/geo/latLng'

@Component
class CampsiteDirections extends Vue {
  @Prop()
  campsite: CampsiteDetails

  get latLng() {
    const { lat, lng } = getPointFromStringOrDefault(this.campsite.point)
    return { lat, lng }
  }
}

export default toNative(CampsiteDirections)
</script>

<style scoped>
section {
  margin-bottom: 1em;
}

.location-subsection {
  font-size: var(--body);
}
</style>
